/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import "./Watcherkanban.scss";
import MainLayout from "../../Common/MainLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { Dropdown, Tab , Tabs , Table } from "react-bootstrap";

export default (props) => {

  return (
    <MainLayout activeMenuItem="kanban" pageName="Kanban Board">
      <div className="kanban-board-main pb-4">
        <div className="container">
          <div className="d-flex cursor-pointer mt-3">
            <FontAwesomeIcon icon={faArrowLeftLong} />
            <h4 className="text-dark ml-2">Published Jobs</h4>
          </div>
          <div className="border border-radius-10 h-100 mt-4 bg-white">
            <div className="d-flex flex-column p-3">
              <div className="d-flex justify-content-between align-items-start">
                <div className="w-50 align-items-center">
                  <h2 className="w-50">Product Designer</h2>
                  <p className="text-grey-4 mt-2 font-weight-medium mb-3">Delhi, India</p>
                </div>
                <div>
                  <img src="/assets/images/link.svg" className="mr-4" />
                  <img src="/assets/images/users.svg" />
                </div>
              </div>
              <div className="d-flex">
                <p className="text-grey-4">Total Candidates:<span className="text-dark">7 </span>{"|"}</p>{" "}
                <p className="text-grey-4 ml-1">Assigned Mentor:<span className="text-dark"> 3 </span></p>
              </div>
              <div className="align-middle py-2">
                <span className="bg-grey border px-2 rounded-lg mr-2 mb-2 d-inline-block">
                  html
                </span>
                <span className="bg-grey border px-2 rounded-lg mr-2 mb-2 d-inline-block">
                  css
                </span>
                <span className="bg-grey border px-2 rounded-lg mr-2 mb-2 d-inline-block">
                  Figma
                </span>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <p className="text-grey-4">Published on 14 Nov 2023</p>
                <p className="custom-pills inprogress d-inline-block p-2">Inprogress</p>
              </div>
            </div>
          </div>
          <Tabs defaultActiveKey="Candidates" className="mt-3">
            <Tab eventKey="Candidates" title="Candidates" className="bg-white mb-5">
              <div className="border rounded-lg">
                <div className="d-flex px-3 pt-3 flex-wrap align-items-center">
                  <div className="btn-group mb-3 flex-wrap">
                    <button className="active">View All </button>
                    <button>Assessment</button>
                    <button>Interview</button>
                    <button>On Hold</button>
                    <button>Offer</button>
                    <button>Hired</button>
                  </div>

                  <div className="custom-search-box ml-auto mb-3">
                    <div className="search-box-with-icon">
                      <span className="icon">
                        <img src="/assets/images/search-lg-icon.svg" alt="search" />
                      </span>
                      <input type="text" placeholder="Search" />
                    </div>
                    <button>
                      <img src="/assets/images/filter-lines.svg" alt="filter" />
                      Filters
                    </button>
                  </div>
                </div>

                <Table responsive="lg" className="custom-table mentor-table">
                  <thead>
                    <tr>
                      <th>Candidate Name</th>
                      <th>Status</th>
                      <th>Skills</th>
                      <th>Last assessed</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="align-middle">
                        <div className="d-flex align-items-center">
                          <button className="border-0 bg-transparent">
                            <img src="/assets/images/star-grey.svg" alt="star" />
                          </button>
                          <div className="d-flex candidate-info">
                            <div className="candiate-img">
                              <img
                                src="/assets/images/user-img.png"
                                alt="candidate"
                              />
                            </div>
                            <div className="candiate-content">
                              <p className="font-weight-bold text-black mb-0">
                                Mukesh Singh
                              </p>
                              <p className="mb-0">mukesh@gmail.com</p>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="align-middle">
                        <span className="custom-tag rounded-pill px-3 tag-applied">
                          Applied
                        </span>
                      </td>
                      <td className="align-middle">
                        <ul className="skill-list">
                          <li className="bg-grey border mr-1 fs-14 mb-1">Figma</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Adobe</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Html</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Figma</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Adobe</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Html</li>
                        </ul>
                      </td>
                      <td className="text-dark align-middle">22 Jan 2022</td>
                    </tr>
                    <tr>
                      <td className="align-middle">
                        <div className="d-flex align-items-center">
                          <button className="border-0 bg-transparent">
                            <img src="/assets/images/star-grey.svg" alt="star" />
                          </button>
                          <div className="d-flex candidate-info">
                            <div className="candiate-img">
                              <img
                                src="/assets/images/user-img.png"
                                alt="candidate"
                              />
                            </div>
                            <div className="candiate-content">
                              <p className="font-weight-bold text-black mb-0">
                                Mukesh Singh
                              </p>
                              <p className="mb-0">mukesh@gmail.com</p>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="align-middle">
                        {" "}
                        <span className="custom-tag rounded-pill px-3 tag-interview">
                          interview
                        </span>
                      </td>
                      <td className="align-middle">
                        <ul className="skill-list">
                          <li className="bg-grey border mr-1 fs-14 mb-1">Figma</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Adobe</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Html</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Figma</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Adobe</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Html</li>
                        </ul>
                      </td>
                      <td className="text-dark align-middle">22 Jan 2022</td>
                    </tr>
                    <tr>
                      <td className="align-middle">
                        <div className="d-flex align-items-center">
                          <button className="border-0 bg-transparent">
                            <img src="/assets/images/star-grey.svg" alt="star" />
                          </button>
                          <div className="d-flex candidate-info">
                            <div className="candiate-img">
                              <img
                                src="/assets/images/user-img.png"
                                alt="candidate"
                              />
                            </div>
                            <div className="candiate-content">
                              <p className="font-weight-bold text-black mb-0">
                                Mukesh Singh
                              </p>
                              <p className="mb-0">mukesh@gmail.com</p>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="align-middle">
                        {" "}
                        <span className="custom-tag rounded-pill px-3 tag-rejected">
                          rejected
                        </span>
                      </td>
                      <td className="align-middle">
                        <ul className="skill-list">
                          <li className="bg-grey border mr-1 fs-14 mb-1">Figma</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Adobe</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Html</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Figma</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Adobe</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Html</li>
                        </ul>
                      </td>
                      <td className="text-dark align-middle">22 Jan 2022</td>
                    </tr>
                    <tr>
                      <td className="align-middle">
                        <div className="d-flex align-items-center">
                          <button className="border-0 bg-transparent">
                            <img src="/assets/images/star-grey.svg" alt="star" />
                          </button>
                          <div className="d-flex candidate-info">
                            <div className="candiate-img">
                              <img
                                src="/assets/images/user-img.png"
                                alt="candidate"
                              />
                            </div>
                            <div className="candiate-content">
                              <p className="font-weight-bold text-black mb-0">
                                Mukesh Singh
                              </p>
                              <p className="mb-0">mukesh@gmail.com</p>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="align-middle">
                        {" "}
                        <span className="custom-tag rounded-pill px-3 tag-offer">
                          offer
                        </span>
                      </td>
                      <td className="align-middle">
                        <ul className="skill-list">
                          <li className="bg-grey border mr-1 fs-14 mb-1">Figma</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Adobe</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Html</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Figma</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Adobe</li>
                          <li className="bg-grey border mr-1 fs-14 mb-1">Html</li>
                        </ul>
                      </td>
                      <td className="text-dark align-middle">22 Jan 2022</td>
                    </tr>
                  </tbody>
                </Table>
                <div className="d-flex p-3 border-top">
                  <span>Page 1 of 10</span>
                  <div className="d-flex ml-auto">
                    <button className="bg-transparent py-2 border rounded-lg shadow-sm px-3 font-weight-semi text-dark">
                      Previous
                    </button>
                    <button className="bg-transparent rounded-lg ml-2 py-2 border shadow-sm px-3 font-weight-semi text-dark">
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </Tab>

            <Tab eventKey="AssessmentKits" title="Assessment Kits">
              Assessment Kits
            </Tab>
            <Tab eventKey="Mentors" title="Mentors">
              Mentors
            </Tab>
          </Tabs>
        </div>
      </div>
    </MainLayout>
  );
};
